export default __webpack_public_path__ + "static/media/cabourg16.0639effa.jpg";